import headerLogoImg from "~/assets/logo.png";
import headerTextImg from "~/assets/header-text.svg";

export default function ComingSoonPage() {
  return (
    <div className="bg-background-base flex min-h-screen flex-col items-center justify-center px-6">
      <div className="flex max-w-md flex-col items-center text-center">
        <div className="mb-10 flex items-center gap-2">
          <div className="flex size-[30px] shrink-0 items-center justify-center overflow-hidden rounded-[7.5px]">
            <img src={headerLogoImg} alt="Blidz" className="size-[30px]" />
          </div>
          <img src={headerTextImg} alt="Blidz" className="h-[22px] w-[66px]" />
        </div>

        <h1 className="text-foreground mb-4 text-2xl font-bold tracking-tight">CHANGES INCOMING SOON.</h1>

        <p className="text-muted-foreground mb-6 text-base leading-relaxed">
          We're making some changes with a bigger focus on improved transparency, clearer communication, and a better
          experience overall. Some features may be temporarily unavailable while we get everything ready.
        </p>

        <p className="text-muted-foreground text-base leading-relaxed">
          We appreciate your patience — it'll be worth it. If you need assistance in the meantime, we're always at{" "}
          <a href="mailto:support@blidz.com" className="text-primary font-medium underline">
            support@blidz.com
          </a>
          .
        </p>
      </div>
    </div>
  );
}
